var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"status-container"},[_c('div',{staticClass:"status",class:_vm.status},[_c('div',{staticClass:"icon"},[(_vm.status == 'check')?_c('i',{staticClass:"icon-check"}):_c('div',[_vm._v(" "+_vm._s(_vm.step)+" ")])])]),(_vm.hasLine)?_c('div',{staticClass:"vertical-line-container"},[_c('div',{staticClass:"vertical-line"})]):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }